import { AgentProfile } from "@/agent-state/use-fetch-agent-profile"
import {
  useCachedRoutingProfiles,
  useRevalidateRoutingProfiles,
} from "@/pages/Users/users-api"

import { useModal } from "../core/Root/modal-root"
import { DialogEditProfile } from "./dialog-edit-profile"

export function useEditProfileModal(agentProfile: AgentProfile | null) {
  const { showModal } = useModal()
  const revalidateRoutingProfiles = useRevalidateRoutingProfiles()
  const { getRoutingProfiles } = useCachedRoutingProfiles(agentProfile)

  const handleEditProfile = async () => {
    if (!agentProfile) return

    // Revalidate then read from cache so the modal receives fresh data.
    // We use getRoutingProfiles() (instead of the reactive value) to avoid
    // the stale closure that would capture the pre-revalidation value.
    await revalidateRoutingProfiles()
    const routingProfiles = getRoutingProfiles()

    await showModal((close) => (
      <DialogEditProfile
        close={close}
        agentProfile={agentProfile}
        routingProfiles={routingProfiles}
      />
    ))
  }

  return { handleEditProfile }
}
